import Vue from 'vue';
import { RawLocation } from 'vue-router';

Vue.mixin({
    computed: {
        phone()
        {
            return ['xs'].includes(this.$mq as string);
        },
        tablet()
        {
            return ['sm', 'md'].includes(this.$mq as string);
        },
        mobile()
        {
            return ['xs', 'sm', 'md'].includes(this.$mq as string);
        },
        laptop()
        {
            return ['lg'].includes(this.$mq as string);
        },
        desktop()
        {
            return ['xl'].includes(this.$mq as string);
        }
    },
    methods: {
        abort(code: number, message: string)
        {
            throw (() =>
            {
                return {
                    code: code,
                    message: message,
                    data: null as any,
                    inner: null as any
                };
            })();
        },
        redirect(location: RawLocation, onComplete?: Function): void
        {
            this.$router.push(location).catch(() => {}).finally(() => onComplete ? onComplete() : null);
        },
        handleException(ex: any, rules: Record<number, (ex: any) => void>): void
        {
            let code = String(ex.code || 0);
            let codes = Object.keys(rules);

            if (codes.indexOf(code) >= 0)
            {
                rules[code](ex);
            }
            else if (codes.indexOf("0") >= 0)
            {
                rules["0"](ex);
            }

            if (!ex.code || ex.code >= 500)
            {
                this.$log.debug(ex);
            }
        }
    }
});
